module.exports = __webpack_public_path__ + "img/logo-aptanutricia.59f51391.png";